import { useNavigate } from 'react-router-dom';

import { CloseButton } from '@app/shared/ui/atoms/Common';
import { Page } from '@app/routes';

export function TopBar() {
  const navigate = useNavigate();

  const handleCloseBtnClick = () => navigate(Page.HOME);

  return (
    <div className="flex items-center justify-end">
      <CloseButton variant="lightgrey" onClick={handleCloseBtnClick} />
    </div>
  );
}
